import gql from "graphql-tag";

export const PRODUCTS_IN_FOCUS = gql`
  query getProductsInFocus($tag: String, $limit: Int, $after: String) {
    products(
      where: { categoryIdIn: [1252], tag: $tag }
      first: $limit
      after: $after
    ) {
      pageInfo {
        hasNextPage
        endCursor
      }
      nodes {
        id
        ... on SimpleProduct {
          productId
          stockStatus
          stockQuantity
          id
          image {
            id
            sourceUrl(size: MEDIUM)
          }
          name
          slug
          onSale
          salePrice
          regularPrice
          productOrigin {
            flag
            name
          }
        }
      }
    }
  }
`;
